import { BASEURL } from '@/utils/realmName'

export function newsImageUrl(value, base = BASEURL()) {
  if (!value) return ''
  try {
    const url = new URL(String(value), base)
    if (!['http:', 'https:'].includes(url.protocol)) return ''
    if (url.hostname === 'snpimg.gtimg.com') return String(base).replace(/\/$/, '') + '/vexe/v1/news/image?url=' + encodeURIComponent(url.href)
    return url.href
  } catch (_) { return '' }
}

// Provider HTML is converted to text/images; styles and active content are not rendered.
export function newsContentBlocks(content) {
  if (Array.isArray(content)) return content.flatMap(item => !item || typeof item !== 'object' ? [] : item.type === 'image' ? [{ type: 'image', url: item.url || item.imgurl }] : item.type === 'text' ? [{ type: 'text', text: String(item.desc || '') }] : [])
  if (typeof content !== 'string' || !content.trim()) return []
  const document = new DOMParser().parseFromString(content, 'text/html'), blocks = []
  let text = ''
  const flush = () => { if (text.trim()) blocks.push({ type: 'text', text: text.trim() }); text = '' }
  const visit = node => {
    if (node.nodeType === 3) { text += node.textContent; return }
    if (node.nodeType !== 1 || ['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'SVG', 'FORM'].includes(node.tagName)) return
    if (node.tagName === 'IMG') { flush(); blocks.push({ type: 'image', url: node.getAttribute('src') }); return }
    if (node.tagName === 'BR') { text += '\n'; return }
    const block = ['P', 'DIV', 'SECTION', 'H1', 'H2', 'H3', 'LI', 'TR', 'BLOCKQUOTE'].includes(node.tagName)
    if (block) flush()
    Array.from(node.childNodes).forEach(visit)
    if (['TD', 'TH'].includes(node.tagName)) text += ' '
    if (block) flush()
  }
  Array.from(document.body.childNodes).forEach(visit); flush()
  return blocks
}
